////////LIBRARY/////////
import React from 'react'
import { Switch, Redirect, useLocation } from 'react-router-dom'
import { shallowEqual, useSelector } from 'react-redux'
import _, { isEqual, map } from 'lodash'
///////COMPONENTS///////
import PrivateRoutes from '../PrivateRoutes'
import PublicRoutes from '../PublicRoutes'
import Layout from '../../../components/Layout'
/**
 *
 * @param {Array} routeListPassed
 * @param {any} rest
 * @return {jsx}
 */
const RenderRoutes = ({ routeList }) => {
	const { translations } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			isRedirect: state.isRedirect.isPrevious,
		}),
		shallowEqual
	)

	const layoutRoute = (elem, id, parent = {}, usingAltPath = false, firstParent = {}) => {
		///////////////////////////////// RENDER ///////////////////////////////////////

		return (
			<Layout
				key={id}
				routes={!isEqual(parent, {}) ? parent : elem}
				translations={translations}
				usingAltPath={usingAltPath}
				firstParent={firstParent}
			>
				{elem.component && <elem.component routes={elem.routes} translations={translations} />}
			</Layout>
		)
	}

	const location = useLocation()

	const wantedLevel = location.pathname.split('/').length - 1

	return (
		<Switch>
			{map(routeList, (elem, id) => {
				// Assuming every protected path is after login, so automatically we have a layout
				// Not necessarily the case anymore
				return elem.isProtected ? (
					<PrivateRoutes path={`${elem.path}`} key={id} breadCrumb={elem.breadCrumb}>
						{elem.routes // Find a way to add wantedLevel and URL control maybe ?
							? map(elem.routes, (elem2, id2) => {
									return (
										<PrivateRoutes path={`${elem.path}${elem2.path}`} key={id2} breadCrumb={`${elem2.breadCrumb}`}>
											{elem2.routes && wantedLevel >= 3
												? map(elem2.routes, (elem3, id3) => {
														let lepath
														let equalsAltPath = false

														// Check if url contains an id, to use the alt path
														if (elem3.hasAltPath) {
															const ar = location.pathname.split('/')
															lepath = `${elem.path}${elem2.path}${elem3.altPath}`
															lepath = lepath.replace(':id', _.last(ar))
															if (isEqual(lepath, location.pathname)) equalsAltPath = true
														}
														return (
															<PrivateRoutes
																path={`${elem.path}${elem2.path}${equalsAltPath ? elem3.altPath : elem3.path}`}
																key={id3}
																breadCrumb={`${elem2.breadCrumb}`}
															>
																{elem3.layout
																	? layoutRoute(elem3, id3, elem2, equalsAltPath, elem)
																	: elem3.component && (
																			<elem3.component routes={elem3.routes} translations={translations} />
																	  )}
															</PrivateRoutes>
														)
												  })
												: elem2.layout
												? layoutRoute(elem2, id2, elem)
												: elem2.component && <elem2.component routes={elem2.routes} translations={translations} />}
										</PrivateRoutes>
									)
							  })
							: elem.layout
							? layoutRoute(elem, id)
							: elem.component && <elem.component routes={elem.routes} translations={translations} />}
					</PrivateRoutes>
				) : elem.layout ? (
					<PublicRoutes path={`${elem.path}`} key={id} breadCrumb={elem.breadCrumb}>
						{layoutRoute(elem, id)}
					</PublicRoutes>
				) : (
					<PublicRoutes path={`${elem.path}`} key={id} breadCrumb={elem.breadCrumb}>
						<elem.component translations={translations} routes={elem.routes} />
					</PublicRoutes>
				)
			})}
			{/*
				map( routeList, ( elem, id ) => {
					return(
					elem.isProtected
						?
						elem.layout
							?

								<PrivateRoutes
									path={ `${ elem.path }` }
									key={ id }
									layout={ elem.layout }
									breadCrumb={elem.breadCrumb}
								>
									<Layout key={id} routes={ elem } translations={translations} isRedirect={isRedirect}>
									{
										elem.routes
											? map( elem.routes, ( route, key ) => {
												return(
													<PrivateRoutes
														breadCrumb={elem.breadCrumb}
														path={ `${elem.path}${route.path}` }
														key={ key }
													>
														<route.component
															routes={ elem.routes }
															translations={translations}
														/>
													</PrivateRoutes>
												)
												
											} )
											:
											<elem.component translations={translations}/>
									}
									</Layout>

								</PrivateRoutes>
							:
							<PrivateRoutes
								path={ `${ elem.path }` }
								key={ id }
								layout={ elem.layout }
								breadCrumb={elem.breadCrumb}
							>
								{
									elem.routes ?
										map( elem.routes, ( route, key ) => (
											<PrivateRoutes
												path={ `${ route.path }` }
												key={ key }
												breadCrumb={elem.breadCrumb}
											>
												<route.component
													translations={translations}
													routes={ route.routes }/>
											</PrivateRoutes>
										) )
										: <elem.component
											routes={ elem.routes }
											translations={translations}
										/>

								}
							</PrivateRoutes>
						:
						elem.layout
							?
							<Layout routes={ elem.routes } translations={translations}>
								<PublicRoutes
									path={ `${ elem.path }` }
									key={ id }
									breadCrumb={elem.breadCrumb}
								>
									{
										elem.routes ?
											map( elem.routes, ( route, key ) => (
												<PublicRoutes
													path={ `${ route.path }` }
													key={ key }
													breadCrumb={elem.breadCrumb}
												>
													<route.component
														routes={ route.routes }
														translations={translations}
													/>
												</PublicRoutes>
											) )
											: <elem.component
												translations={translations}
												routes={ elem.routes }/>

									}
								</PublicRoutes>
							</Layout>

							:
							<PublicRoutes
								path={ `${ elem.path }` }
								key={ id }
								layout={ elem.layout }
								breadCrumb={elem.breadCrumb}
							>
								{
									elem.routes ?
										map( elem.routes, ( route, key ) => (
											<PublicRoutes
												path={ `${ route.path }` }
												key={ key }
												layout={ route.layout }
												breadCrumb={elem.breadCrumb}
											>
												<route.component translations={translations}
													routes={ route.routes }/>
											</PublicRoutes>
										) )
										: <elem.component
											routes={ elem.routes }
											translations={translations}
										/>
								}
							</PublicRoutes>
					)} )
			*/}
			<Redirect to="/home" />
		</Switch>
	)
}

RenderRoutes.propTypes = {}
RenderRoutes.defaultProps = {}

export default RenderRoutes

// <Switch>
// 	<PublicRoutes path={routeList.login}>
// 		<Route>
// 			<Login />
//        </Route>
// 		<Route>
//
//        </Route>
//    </PublicRoutes>
//
// 	<PrivateRoutes
//        layout
//        strict
//        exact
//        path={routeList.home}
//    >
// 		<Home />
//    </PrivateRoutes>
// 	<Redirect to={routeList.home} />
// </Switch>
